import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { AlertTriangle } from "lucide-react";

const FLAG_LABEL: Record<string, string> = {
  pause_transactions: "Transactions are paused",
  disable_withdrawals: "Withdrawals are disabled",
  disable_spin: "Spin is disabled",
  disable_rewards: "Rewards are disabled",
  disable_signups: "New signups are disabled",
};

/**
 * Shows a top banner whenever a kill-switch is active.
 * Reads system_flags via RLS — only admins can read, but the page degrades
 * silently for normal users (RPC returns empty), and we do a public probe
 * via a security-definer helper for is_flag_on.
 */
export const SystemStatusBanner = () => {
  const [active, setActive] = useState<string[]>([]);

  useEffect(() => {
    let cancelled = false;
    const check = async () => {
      const keys = Object.keys(FLAG_LABEL);
      const results = await Promise.all(
        keys.map(async (k) => {
          const { data } = await supabase.rpc("is_flag_on", { _key: k });
          return data === true ? k : null;
        }),
      );
      if (!cancelled) setActive(results.filter(Boolean) as string[]);
    };
    check();
    const id = setInterval(check, 30_000);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  if (active.length === 0) return null;

  return (
    <div className="bg-destructive text-destructive-foreground px-4 py-2 text-xs sm:text-sm flex items-center gap-2 justify-center">
      <AlertTriangle className="h-4 w-4 shrink-0" />
      <span>{active.map((k) => FLAG_LABEL[k]).join(" • ")}</span>
    </div>
  );
};
